import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiZoomIn, FiZoomOut } = FiIcons;

const ImageViewer = ({ imageUrl, alt, onClose }) => {
  const [scale, setScale] = useState(1);
  
  // Handle escape key to close modal
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);
  
  const handleZoomIn = (e) => {
    e.stopPropagation();
    setScale(prev => Math.min(prev + 0.25, 3));
  };
  
  const handleZoomOut = (e) => {
    e.stopPropagation();
    setScale(prev => Math.max(prev - 0.25, 0.5));
  };
  
  const handleOverlayClick = () => {
    onClose();
  };
  
  const handleImageClick = (e) => {
    e.stopPropagation();
  };

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4"
      onClick={handleOverlayClick}
      style={{ zIndex: 9999 }}
    >
      <div className="relative w-full max-w-4xl">
        {/* Close button */}
        <button 
          className="absolute -top-12 right-0 text-white p-2 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-200" 
          onClick={onClose}
        >
          <SafeIcon icon={FiX} className="text-2xl" />
        </button>

        {/* Zoom controls */}
        <div className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 bg-[#8d2424] rounded-full px-4 py-2">
          <button 
            className="text-white hover:text-gray-200 transition-colors p-1" 
            onClick={handleZoomOut}
          >
            <SafeIcon icon={FiZoomOut} className="text-xl" />
          </button>
          <span className="text-white font-medium">{Math.round(scale * 100)}%</span>
          <button 
            className="text-white hover:text-gray-200 transition-colors p-1" 
            onClick={handleZoomIn}
          >
            <SafeIcon icon={FiZoomIn} className="text-xl" />
          </button>
        </div>

        {/* Image container */}
        <motion.div 
          className="bg-white bg-opacity-10 p-1 rounded-lg overflow-hidden"
          onClick={handleImageClick}
        >
          <motion.div
            className="overflow-auto max-h-[calc(100vh-120px)] flex items-center justify-center"
            style={{ maxWidth: '100%' }}
          >
            <motion.img
              src={imageUrl}
              alt={alt || "Product image"}
              className="object-contain"
              style={{
                transform: `scale(${scale})`,
                transformOrigin: 'center center',
                transition: 'transform 0.2s ease-out'
              }}
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/400x400?text=Image+Not+Available';
              }}
            />
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ImageViewer;